import { Badge } from '@/shared/components/ui/badge';
import { OrderStatus } from '@/types/api/order';
import { orderStatusBadge, orderStatusLabel } from '../utils/order-status';

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  return <Badge className={orderStatusBadge(status)}>{orderStatusLabel(status)}</Badge>;
}
